import React from 'react';
import { Input } from 'antd';
import Status from '../status';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import style from './style.module.scss';

const CurrencyIcon = () => {
  return (
    <div className={style['currency-icon-container']}>
      <div className={style['currency-icon']}>₹</div>
    </div>
  );
};

const FieldInput = ({
  name,
  label,
  type,
  placeholder,
  isRequired = false,
  isUnit,
  showError = true,
  isPrice = false,
  onKeyPress = () => {},
  subLabel,
  subText,
  ...restProps
}) => (
  <Field name={name}>
    {({ field, meta: { error, touched }, x }) => {
      return (
        <div className={style['input-wrapper']}>
          {!!isRequired && (
            <p className={style['required-check']}>
              {isRequired && <Status isFilled={!error && !!field?.value} />}
            </p>
          )}

          <div className={subText ? style['label-box-with-subtext'] : style['label-box']}>
            <div className={style['label-group']}>
              <p className={style.label}>{label}</p>
              <p className={style['sub-label']}>{subLabel}</p>
            </div>

            <div className={style['box']}>
              <Input
                prefix={isPrice && <CurrencyIcon />}
                status={touched && error ? 'error' : ''}
                type={type}
                placeholder={placeholder}
                onWheel={(event) => event.currentTarget.blur()}
                onKeyPress={onKeyPress}
                {...field}
                {...restProps}
                addonAfter={isUnit}
              />
              {!!subText && <p className={style['sub-text']}>{subText}</p>}
              {touched && error && <p className={style.error}>{error}</p>}
            </div>
          </div>
        </div>
      );
    }}
  </Field>
);

FieldInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'password', 'number']),
  placeholder: PropTypes.string,
};

FieldInput.defaultProps = {
  type: 'text',
};

export default FieldInput;
